<template>
  <div class="plugin-wrapper image_2_text layout layout--full-width flex flex-column cover scroll-section" v-if="config">
    <div class="cover__background flex-fill">
      <!-- <picture class="text-image__visual-container">
        <source media="(min-width: 768px)" srcset="../assets/imgs/offers/2020w09-hr-top.jpg, ../assets/imgs/offers/2020w09-hr-top.jpg 2x">
        <source media="(min-width: 0)" srcset="../assets/imgs/offers/2020w09-hr-top-mobile.jpg, ../assets/imgs/offers/2020w09-hr-top-mobile.jpg 2x">
        <img class="image--full-width image--fit lazyloaded" alt="Hair rituel by Sisley" srcset="../assets/imgs/offers/2020w01-hr-top.jpg 2x" src="../assets/imgs/offers/2020w01-hr-top.jpg">
      </picture> -->
      <img class="image--full-width image--fit lazyloaded" :alt="config.text1" :src="config.src.pc" />
    </div>
    <div id="hero-content" class="cover__text-wrapper flex-column display-flex-xs layout text--center c-wrapper-link__container">
      <div class="start-xs">
        <h2 class="cover__subtitle heading-h4" style="color: #fff;">{{config.text1}}</h2>
      </div>
      <div class="ms-row collapsed start-xs">
        <p class="col-xs-8 cover__title heading-h1" style="color: #fff;">{{config.text2}}<br>
          <!-- <p><span class="c-button c-button--primary cover__cta">DÉCOUVRIR</span> </p> -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Image2Text",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  created() {
    console.log(this.config);
  }
}
</script>

<style>
.cover { width: 48rem; height: calc(100vh + 4.0625rem); justify-content: center; overflow: hidden; }
.scroll-section { position: relative; }
.cover__background { height: 100%; }
.cover__text-wrapper {
  width: 100%; height: 100%; padding: 0 1.125rem 9.6875rem; align-items: start; justify-content: flex-end;
  position: absolute; left: 50%; transform: translateX(-50%); top: 0; z-index: 1;
}
.cover__subtitle { font-size: 1.375rem; }
.cover__title { font-size: 2.625rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; }
.cover__cta { margin-top: 1.875rem; }
@media screen and (min-width: 48em) {
  .cover { width: 160rem; }
  .cover__text-wrapper { padding: 0 3.75rem 9.6875rem; }
}
@media screen and (min-width: 64em) {
  .cover__text-wrapper { padding: 0 1.875rem 9.6875rem; padding: 0 0 9.6875rem; }
  .cover__subtitle { font-size: 1.875rem; }
  .cover__title { font-size: 5.125rem; }
}
@media screen and (min-width: 75em) {
  .cover { height: 100vh; }
}
@media only screen and (max-width: 1480px) and (min-width: 1024px) {
  .cover__title { font-size: 3.125rem; }
}
</style>